import Vue from 'vue'

Vue.filter('formatNumber', (val) => {
    if(val === null) {
      return val
    }
    val = Number.isNaN(val) || isNaN(parseFloat(val)) ? 0 : val
    var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 2}).format(val)
    ret = ret.replace("\u2019", "'")
    return ret
})
Vue.filter('formatInteger', (val) => {
    if(val === null) {
      return val
    }
    val = Number.isNaN(val) || isNaN(parseInt(val)) ? 0 : val
    var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 0}).format(Math.round(val))
    ret = ret.replace("\u2019", "'")
    return ret
})
Vue.filter('formatPrice', (val) => {
  if(!val) return null
  var ret = new Intl.NumberFormat('de-CH', {maximumFractionDigits: 2}).format(val)
  ret = ret.replace("\u2019", "'")
  return ret
})

Vue.filter('formatPricePercentage', (val) => {
  if(!val) return null
  return (Math.round(val * 100 * 100) / 100).toFixed(2)
})

Vue.filter('formatRoundNumber', (val) => {
  if(val === null) {
    return val
  }
  val = Number.isNaN(val) || isNaN(parseFloat(val)) ? 0 : val
  var val = roundByNum(val, 0.05)
  var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 2}).format(val)
  ret = ret.replace("\u2019", "'")
  return ret
})

function roundByNum(num, rounder) {
  var multiplier = 1/(rounder||0.5);
  return Math.round(num*multiplier)/multiplier;
}
